import type { ImportSummary, ListResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { ImportsGateway } from './imports.gateway';

/**
 * Real implementation over the shared api client. This is the single place that
 * knows the client-imports endpoints. `api.get` unwraps the `{ success, data }`
 * envelope, so we get the payloads directly.
 */
export const httpImportsGateway: ImportsGateway = {
  fetchLists: () => api.get<ListResponse[]>('/lists?origin=client'),
  fetchSummary: () => api.get<ImportSummary>('/lists/import-summary'),
  sendCsmMessage: async (message) => {
    await api.post<void>('/licences/current/csm-message', { message });
  },
};
